export default {
  toasts: {
    auth_token_invalid: 'Token di autenticazione non valido',
    host_access_refused:
      'Questo indirizzo appartiene a un partner di cui il tuo account non fa parte. Accedi dal tuo indirizzo.',
  },
};
